import { STRINGS } from '@/constants/strings';
import type { auth } from '@/features/auth/types';

import type { NotificationPreferenceItem } from './types';

const strings = STRINGS.guardianProfile.notificationPreferences;

export const DEFAULT_NOTIFICATION_PREFERENCES: auth.NotificationPreferences = {
  classReminders: false,
  coachNotes: false,
  tournamentUpdates: false,
  coGuardianActivity: false,
  shopDeals: false,
};

export const NOTIFICATION_PREFERENCE_ITEMS: NotificationPreferenceItem[] = [
  {
    key: 'classReminders',
    icon: 'IcNotification',
    title: strings.rows.classReminders.title,
    subtitle: strings.rows.classReminders.subtitle,
  },
  {
    key: 'coachNotes',
    icon: 'IcNote',
    title: strings.rows.coachNotes.title,
    subtitle: strings.rows.coachNotes.subtitle,
  },
  {
    key: 'tournamentUpdates',
    icon: 'IcAward',
    title: strings.rows.tournamentUpdates.title,
    subtitle: strings.rows.tournamentUpdates.subtitle,
  },
  {
    key: 'coGuardianActivity',
    icon: 'IcPeople',
    title: strings.rows.coGuardianActivity.title,
    subtitle: strings.rows.coGuardianActivity.subtitle,
  },
];
